import gql from 'graphql-tag';

export default gql`
  fragment memberFragment on Member {
    id
    firstName
    surname
    email
    advancedBookingsAdditionalDays
    phoneNumber
    noFacebook
    noInstagram
    contactPermission
    subscribedCityIds
    avatarURL
    termsAndPrivacy
    favouriteIds
    created
    confirmedBookingsCount
    accountBalances {
      edges {
        node {
          amount
          currency
        }
      }
    }
    activatedCreditsSum
    customerValueNZD
    lastBookingDate
    expiringCredit {
      edges {
        node {
          id
        }
      }
    }
    currentLoyaltyTier {
      id
      startDate
      endDate
      pointsEarned
      definition {
        id
        title
      }
    }
    nextLoyaltyTier {
      id
      pointsEarned
    }
    subscribedCityIds
    city {
      id
      menuTitle
      slug
    }
    promoCode {
      id
      code
      link
    }
  }
`;
